// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import './assets/css/style.css';
import './assets/css/animate.min.css';

import './assets/js/jquery-1.9.1.min.js';
import './assets/js/mobile.js';
import './assets/js/common.js';

import api from'./api/api.js';//接口方法名称
import utils from './utils/utils.js';//工具方法

import Vant from 'vant';
import 'vant/lib/index.css';

import './assets/css/index.css';



//vant 懒加载
import { Toast, Dialog } from 'vant';

Vue.use(Vant);
Vue.use(Toast);
Vue.use(Dialog);

import wx from 'weixin-js-sdk';
Vue.prototype.$wx = wx;

import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'
Vue.use(vueMiniPlayer)

import Request from './utils/request' // 引入封装的文件 - 请求接口方法
const { request, baseURL } = Request;

Vue.prototype.$http = request;
Vue.prototype.baseURL = baseURL;

Vue.prototype.api = api;
Vue.prototype.utils = utils;
Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

Vue.config.ignoredElements = ['wx-open-launch-weapp'];

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


//npm install weixin-js-sdk --save  微信sdk

//npm install --save vue-monoplasty-slide-verify 滑块验证



// WEBPACK FOOTER //
// ./src/main.js